import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import EditGrid from './EditGrid';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import styles from './style.js';
import ListItemText from '@mui/material/ListItemText';
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'

class EditDialog extends React.Component {
  state = {
    open: false,
    fieldDatas:[],
    gridFunctions:{}
  };

  componentDidMount() {
    const { selectedData } = this.props;
    this.setState({ fieldDatas: selectedData}, () => {this.afterSetFieldDatas(); });
  }

  afterSetFieldDatas() {  
    // const { fields } = this.props;
    // const { fieldDatas } = this.state;
    
    // var gridCount=0;
    // fields.filter(item => item.type=="array").map((item) =>{
    //   gridCount++;
    //   const grdFncText="grdFunc"+item.field;
      
    //   if(fieldDatas!=null && fieldDatas.length>0)
    //     this.state.gridFunctions[grdFncText].state.gridRows= fieldDatas[item.field];

    //   this.state.gridFunctions[grdFncText].state.gridColumns= item.arrayColumns;
    //   this.state.gridFunctions[grdFncText].state.columnVisibilityModel= item.columnVisibilityModel;
    //   this.state.gridFunctions[grdFncText].state.functionId= grdFncText;
    // });
  }

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.props.onClose();
  };

  handleApprove = () => {
    const { selectedData,fields } = this.props;
    const { gridFunctions } = this.state;
    fields.filter(item => item.type=="array").map((item) =>{
      const grdFnc=gridFunctions[item.field];
      selectedData[item.field]=grdFnc.GetRows();
    });

    this.props.handleApprove();
  };

  handleChange = event => {
    const { selectedData,fields } = this.props;
    
    const fieldName = event.target.id;
    const fieldValue = event.target.value;

    Array.prototype.forEach.call(fields, value => {
      if (value.field == fieldName) {
        selectedData[fieldName]= fieldValue;   
      }
    });

    this.setState({ fieldDatas: selectedData });
  };

  handleSelectChange = event => {
    const { selectedData,fields } = this.props;
    const fieldName = event.target.name;
    const fieldValue = event.target.value;

    //Seçilen id'ye göre obje bulunur.Grid render ettiğinde texti göstermesi ayarlandı.
    let isBreak=false;
    for (let i = 0; i < fields.length; i++) {
      if(isBreak)
        break;

      let value=fields[i];
      if (value.field == fieldName) {
        if(value.dataList!=undefined){
          for (let j = 0; j < value.dataList.length; j++) {
            let valueSub=value.dataList[j];
            if (valueSub[value.keyField] == fieldValue) {
              selectedData[fieldName]= valueSub;
              isBreak=true;
              break;
            }
          }
        }
      }
    } 

    this.setState({ fieldDatas: selectedData });
  };

  handleCheckBoxChange = event => {
    const { selectedData,fields } = this.props;
    const fieldName = event.target.name;
    const fieldValue = event.target.checked;

    Array.prototype.forEach.call(fields, value => {
      if (value.field == fieldName) {
        selectedData[fieldName]= fieldValue;   
      }
    });

    this.setState({ fieldDatas: selectedData });
  };

  GridLoad(x)
  {
    const { fields } = this.props;
    const { fieldDatas } = this.state;

    var isbreak=false;
    fields.filter(item => item.type=="array").map((item) =>{
      const grdFncText=item.field;
      
      if(!isbreak&&this.state.gridFunctions[grdFncText]==null){
        this.state.gridFunctions[grdFncText]=x;

        if(fieldDatas!=null && fieldDatas[grdFncText]!=null && fieldDatas[grdFncText].length>0)
          this.state.gridFunctions[grdFncText].state.gridRows= fieldDatas[item.field];

        this.state.gridFunctions[grdFncText].state.gridColumns= item.arrayColumns;
        this.state.gridFunctions[grdFncText].state.columnVisibilityModel= item.columnVisibilityModel;
        isbreak= true;
      }
    });

  }

  render() {
    const { fullScreen,fields } = this.props;
    const { fieldDatas } = this.state;

    return (
      <div>
        <Dialog
          fullScreen={fullScreen}
          open={this.props.open}
          onClose={this.handleClose}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle id="responsive-dialog-title">
            <div style={styles.title}>{this.props.title}</div>
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              {/* {this.props.text} */}
              <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                {fields.filter(item => !item.hide).map((item) =>
                {switch(item.type) {
                  case 'array':
                    return <Grid item xs={12}>
                              <EditGrid ref={this.gridFunctions} getLoadFunc={this.GridLoad.bind(this)} dialogTitle={item.text} gridHeight={200} isChild={true} {...this.props}/>
                            </Grid>;
                  case 'singleSelect':
                    return <Grid item xs={12}><InputLabel id={item.field+"Lbl"} style={styles.label}>{item.labelText}</InputLabel>
                            <Select
                            fullWidth
                            labelId={item.field+"Lbl"}
                            value={fieldDatas[item.field]!=undefined?fieldDatas[item.field][item.keyField]:fieldDatas[item.field]}
                            name={item.field}
                            sx={{ maxWidth: '300px' }}
                            onChange={this.handleSelectChange}>
                            {item.dataList.map((lItem) => (
                              <MenuItem value={lItem[item.keyField]}>
                                <div style={styles.selectField}>{lItem[item.valueField]}</div>
                              </MenuItem>
                            ))}
                          </Select></Grid>;
                  case 'multiSelect':
                    return <Grid item xs={12}><InputLabel id={item.field+"Lbl"}>{item.labelText}</InputLabel>
                            <Select
                              labelId={item.field+"Lbl"}
                              /* id="demo-multiple-checkbox" */
                              multiple
                              value={fieldDatas[item.field]!=undefined?fieldDatas[item.field][item.keyField]:fieldDatas[item.field]}
                              onChange={this.handleSelectChange}
                              sx={styles.selectField}
                              /* input={<OutlinedInput label="Tag" />} */
                              renderValue={(selected) => selected.join(', ')}
                              /* MenuProps={MenuProps} */
                            >
                              {item.dataList.map((lItem) => (
                                <MenuItem value={lItem[item.keyField]}>
                                  <Checkbox checked={fieldDatas[item.field][item.keyField].indexOf(lItem) > -1} />
                                  <ListItemText primary={lItem} />
                                    <div style={styles.selectField}>{lItem[item.valueField]}</div>
                                </MenuItem>
                              ))}                              
                            </Select>
                           </Grid>
                  case 'checkbox':
                    return  <Grid item xs={12}>
                              <FormControlLabel control={<Checkbox name={item.field} size="large" checked={fieldDatas[item.field]} onChange={this.handleCheckBoxChange} 
                              />} label={item.text} />
                            </Grid>;
                  case 'phone':
                    return  <Grid item xs={12}>
                              <PhoneInput
                                inputProps={{
                                  id: item.field,
                                  required: true
                                }}
                                country={'tr'}
                                disableDropdown
                                countryCodeEditable = {false}
                                value={fieldDatas[item.field]}
                                onBlur={this.handleChange}
                              />                              
                            </Grid>;
                  case 'number':
                    return  <Grid item>
                              <TextField sx={styles.textField} id={item.field} label={item.text} type="number" variant="outlined" value={fieldDatas[item.field]} onChange={this.handleChange}/>
                            </Grid>;
                  case 'password':
                    return  <Grid item>
                              <TextField sx={styles.textField} id={item.field} label={item.text} type="password" variant="outlined" value={fieldDatas[item.field]} onChange={this.handleChange}/>
                            </Grid>;                           
                  default:
                    return <Grid item>
                            <TextField sx={styles.textField} id={item.field} label={item.text} variant="outlined" value={fieldDatas[item.field]} onChange={this.handleChange}/>
                          </Grid>;
                  }} 
                )}
              </Grid>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} style={styles.cancelButton} variant="outlined">
              İptal
            </Button>
            <Button onClick={this.handleApprove} style={styles.saveButton} autoFocus variant="outlined">
              Tamam
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

EditDialog.propTypes = {
  fullScreen: PropTypes.bool.isRequired
};

export default withMobileDialog()(EditDialog);
